import { useContext } from "react";
import { FormContext } from "../../context";

const useFormContext = () => {
  const formik = useContext(FormContext);
  return formik;
};

export default useFormContext;
